import { ArrowsDownload, Button } from "@datagame/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { MobileStickyBar } from "../../shared/MobileStickyBar";
import { UploadSection } from "./UploadSection";
import { UploadFileModal } from "../../shared/modals/UploadFileModal";
import { LibrarySection } from "./LibrarySection";

import styles from "./LibraryView.module.scss";

export const LibraryView = () => {
  const { t } = useTranslation();
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

  return (
    <>
      <div className={styles.container}>
        <MobileStickyBar
          header={t("library:uploadSection.header")}
          description={t("library:uploadSection.description")}
          button={
            <Button
              icon={<ArrowsDownload />}
              iconSide="left"
              kind="outline"
              className={styles.browseButton}
              onClick={() => setIsUploadModalOpen(true)}
            >
              {t("library:uploadSection.browse")}
            </Button>
          }
        />

        <LibrarySection />

        <UploadSection />
      </div>

      {isUploadModalOpen && <UploadFileModal onClose={() => setIsUploadModalOpen(false)} />}
    </>
  );
};
